import axios from 'axios';
import {
  BACKEND_BASE_URL,
  COUNTRIES_API_KEY,
  COUNTRIES_BASE_URL,
  KEY_ACCESS_TOKEN,
  KEY_CONFIG_URL,
  KEY_REFRESH_TOKEN,
} from '../Constants/constant';

export let axiosInstance;
const configUrl = KEY_CONFIG_URL;
// let appConfig;

export const getAxiosInstance = (data) => {
  // appConfig = data[0]?.config;
  axiosInstance = axios.create({
    baseURL: BACKEND_BASE_URL, //`${appConfig.apiBaseUrl}`,
  });

  axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    const refreshToken = localStorage.getItem(KEY_REFRESH_TOKEN);
    if (refreshToken) {
      req.headers['access-token'] = refreshToken;
    }
    if (token) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }
      if (
        localStorage.refresh_token &&
        (error.response.status === 402 || error.response.status === 502)
      ) {
        localStorage.clear();
        window.location.reload();
        return;
      }
      // var config = {
      //   method: 'get',
      //   baseURL: `${BACKEND_BASE_URL}app/azureToken`,
      // };
      // return axios(config).then(function (response) {
      //   localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
      //   error.response.config.headers[
      //     'Authorization'
      //   ] = `Bearer ${response.data.access_token}`;
      // });
      return axios(error.response.config);
    }
  );
};

export const getConfig = async () => {
  // const path = 'apply-vvi.ken42.com';
  // const res = await axios.get(`${configUrl}/${path}`);
  // return res && res.data ? res.data : null;
  try{
    const configJson = process.env.REACT_APP_CONFIG_JSON;
        if (!configJson) {
          console.warn('CONFIG_JSON not found in environment variables');
          return null;
        }
    
        const config = typeof configJson === "string" ? JSON.parse(configJson) : configJson;
        return config;
      } catch (error) {
        console.error('Error parsing CONFIG_JSON:', error);
        return null;
      }
};

export const getAllPrograms = async () => {
  const path = `forms`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getFormByFormId = async (formId) => {
  const path = `form`;
  const res = await axiosInstance.get(`${path}`, { params: { formId } });
  return res && res.data ? res.data : null;
};

export const getApplicationsByApplicantId = async (contactId) => {
  const path = `applications`;
  const res = await axiosInstance.get(`${path}`, { params: { contactId } });
  return res && res.data ? res.data : null;
};

export const getApplicationByApplicationId = async (applicationId) => {
  const path = `application`;
  const res = await axiosInstance.get(`${path}`, { params: { applicationId } });
  return res && res.data ? res.data : null;
};

export const getContactInfoByContactId = async (contactId) => {
  const path = `applicant`;
  const res = await axiosInstance.get(`${path}`, { params: { contactId } });
  return res && res.data ? res.data : null;
};

export const createUpdateApplication = async (data) => {
  const path = `/application/save`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const deleteApplicationRecords = async (data) => {
  const delData = { data: data };
  const path = `deleterecord`;
  const res = await axiosInstance.delete(`${path}`, delData);
  return res && res.data ? res.data : null;
};

export const deleteRecordData = async (data) => {
  const path = `delete`;
  console.log(data, "contactId");
  const res = await axiosInstance.delete(`${path}?${data}`);
  return res && res.data ? res.data : null;
}

export const getDocuments = async (applicationId) => {
  const path = `documentstatus`;
  const res = await axiosInstance.get(`${path}`, { params: { applicationId } });
  return res && res.data ? res.data : null;
};

export const createDocuments = async (data) => {
  const path = `/application/save`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getNotifications = async (contactId) => {
  const path = `notifications`;
  const res = await axiosInstance.get(`${path}`, { params: { contactId } });
  return res && res.data ? res.data : null;
};

export const getImportantDates = async () => {
  const path = `importantdates`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getFeeDetails = async (contactId) => {
  const path = `feedetails`;
  const res = await axiosInstance.get(`${path}`, { params: { contactId } });
  return res && res.data ? res.data : null;
};

export const postFeeCoupon = async (data) => {
  const path = `validatecoupon`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getOfferLetter = async (contactId) => {
  const path = `allofferletters`;
  const res = await axiosInstance.get(`${path}`, { params: { contactId } });
  return res && res.data ? res.data : null;
};

export const getFeeReceipt = async (transactionId) => {
  const path = `transactions`;
  const res = await axiosInstance.get(`${path}`, { params: { transactionId } });
  return res && res.data ? res.data : null;
};

export const getQuestionare = async (contactId) => {
  const path = `questionarie`;
  const res = await axiosInstance.get(`${path}`, { params: { contactId } });
  return res && res.data ? res.data : null;
};

export const postQuestionare = async (data) => {
  const path = `miscsave`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getTransactionDetailsByTransactionId = async (paymentId) => {
  const path = `transaction`;
  const res = await axiosInstance.get(`${path}`, { params: { paymentId } });
  return res && res.data ? res.data : null;
};

export const postAppliedCouponCode = async (data) => {
  const path = `appliedcouponcodeAPI`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getApplicantByEmail = async (email) => {
  const path = `verifyemail`;
  const res = await axiosInstance.get(`${path}`, { params: { email } });
  return res && res.data ? res.data : null;
};

export const getDocumentByDocId = async (docId) => {
  const path = `miscdocument`;
  const res = await axiosInstance.get(`${path}`, { params: { docId } });
  return res && res.data ? res.data : null;
};

export const postInitatePayment = async (data) => {
  const path = `razorpay`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getRenderingDetails = async (applicantid) => {
  const path = `renderingdetails`;
  const res = await axiosInstance.get(`${path}`, { params: { applicantid } });
  return res && res.data ? res.data : null;
};

const axiosinstancecountries = axios.create({
  baseURL: COUNTRIES_BASE_URL,
  headers: {
    accept: 'application/json',
    'X-CSCAPI-KEY': COUNTRIES_API_KEY,
  },
});

export const getCountries = async () => {
  const path = 'v1/countries';
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};

export const getStates = async (iso) => {
  const path = `v1/countries/${iso}/states`;
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};

export const getCities = async (iso, siso) => {
  const path = `v1/countries/${iso}/states/${siso}/cities`;
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};
